import { DEFAULT_PUBLIC_PROGRAM_CODE, programPublicPath } from './routes';

/** Company social profiles — used by the Social menu, the footer and the home page. */
export const SOCIAL_LINKS = {
  linkedin: 'https://www.linkedin.com/company/112104398/',
  x: 'https://x.com/enpropeL',
  instagram: 'https://www.instagram.com/enpropel',
  facebook:
    'https://www.facebook.com/people/Enprope-L/pfbid02FxjQErzA2d95WGdsFMss4LU8u5x7Fmb85cVf5sE8RLhYsHSFSwpHPngMSRGqjVitl',
} as const;

export interface FooterLink {
  label: string;
  to: string;
}

export interface FooterColumn {
  title: string;
  links: FooterLink[];
}

const CONTACT_US = '/contact-us';

/** Footer link columns. Items without a dedicated page yet point at the closest existing page. */
export const FOOTER_COLUMNS: FooterColumn[] = [
  {
    title: 'For Students',
    links: [
      { label: 'Internships', to: '/internships' },
      { label: 'Jobs', to: '/jobs' },
      { label: 'Mentorship', to: '/mentorships' },
      { label: 'Programs / Events', to: '/programs' },
      { label: 'Community Hub', to: '/community' },
    ],
  },
  {
    title: 'For Institutions',
    links: [
      { label: 'eCAP Program', to: CONTACT_US },
      { label: 'Industry Connect', to: CONTACT_US },
      { label: 'Hackathons', to: '/programs' },
      { label: 'Student Development', to: CONTACT_US },
      { label: 'Partner With Us', to: CONTACT_US },
    ],
  },
  {
    title: 'For Organizations',
    links: [
      { label: 'Post Opportunities', to: '/register?type=organization' },
      { label: 'Campus Engagement', to: CONTACT_US },
      { label: 'Talent Hub', to: CONTACT_US },
      { label: 'Partner With Us', to: CONTACT_US },
    ],
  },
  {
    title: 'Programs / Events',
    links: [
      { label: 'All Programs', to: '/programs' },
      { label: 'IgniteX 2026', to: programPublicPath(DEFAULT_PUBLIC_PROGRAM_CODE) },
      { label: 'Events', to: '/events' },
      { label: 'Scholarships', to: '/scholarships' },
    ],
  },
  {
    title: 'Sponsorship',
    links: [
      { label: 'Why Sponsor', to: CONTACT_US },
      { label: 'Partnership Options', to: CONTACT_US },
      { label: 'Our Sponsors', to: '/our-partners' },
      { label: 'Impact Stories', to: '/accolades' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About Us', to: '/about-us' },
      { label: 'News & Media', to: '/news-media' },
      { label: 'Contact Us', to: CONTACT_US },
    ],
  },
];
